let exportSdk;

const isServer = () => typeof window === 'undefined';

if (isServer()) {
  // Use eval to skip webpack from bundling SDK in Node
  // eslint-disable-next-line no-eval
  exportSdk = eval('require')('sharetribe-flex-sdk');
} else {
  exportSdk = require('sharetribe-flex-sdk');
}

const { createInstance, types, transit, util, file } = exportSdk;

export { createInstance, types, transit, util, file };
